import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { AFScore, RLGLScore } from "../../models/reports";
import { convertDOBintoAge, getPatientAge } from "../../utils/sharedFunction";
import CustomBarGraph from "../Graphs/CustomBarGraph";
import TrendlineGraph from "../../components/Graphs/TrendlineGraph";
import TrendLineGraphSvg from "../../components/Graphs/TrendLineGraphSvg";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { TestType } from "../../models/Enums";
interface Props {
  score: AFScore;
}

const AF_Test: React.FC<Props> = ({ score }) => {
  const patientInfo = useRecoilValue(PatientState);
  const [reportScore, setReportScore] = useState<AFScore>(score);
  const [isShowArmsMetrics, setIsShowArmsMetrics] = useState(false);
  const [isShowLateralMetrics, setIsShowLateralMetrics] = useState(false);
  const [isShowLeanMetrics, setIsShowLeanMetrics] = useState(false);
  console.log("AF_Test score: ", score);
  const [graphDetails, setGraphDetails] = useState<any>({
    lineGraphValues: [],
    RangeIds: [],
    TestType: TestType.game_AF,
    graphSvg: null,
  });
  const formatNumber = (value: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  };
  useEffect(() => {
    setReportScore(score);
    if (score.difficulty.movementType.toLocaleLowerCase() === "hands") {
      setIsShowArmsMetrics(true);
    } else if (
      score.difficulty.movementType.toLocaleLowerCase().includes("lateral")
    ) {
      setIsShowLateralMetrics(true);
    } else if (
      score.difficulty.movementType.toLocaleLowerCase().includes("lean")
    ) {
      setIsShowLeanMetrics(true);
    }

    // const timesArray = score.averageArmOffsetPolled[0];
    const values = score.averageArmOffsetPolled
      .split(",")
      .filter((v) => v.trim() !== "")
      .map(Number);
    console.log("Values Array:", values);

    const labels = values.map((_, index) => `${index * 5}`);
    console.log("AF_Test Labels Array:", labels);
    setGraphDetails({
      lineGraphValues: values,
      RangeIds: labels,
      TestType: TestType.game_AF,
      graphSvg: null,
    });
  }, [score]);
  return (
    <>
      <IonGrid placeholder={undefined}>
        <IonRow placeholder={undefined}>
          <IonCol placeholder={undefined}>
            {graphDetails.RangeIds.length > 0 &&
            score.averageArmOffsetPolled !== "-" ? (
              <div className="cutom-graph-wrap ap-graph-wrap">
                <div className="cutom-graph-wrap-header">
                  <div className="left-sec">
                    <div className="svg-icon">
                      {/* <TrendLineGraphSvg
                        testLookupId={TestType.gait}
                        metricFilter={0}
                      ></TrendLineGraphSvg> */}
                      <svg
                        width="23"
                        height="28"
                        viewBox="0 0 23 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.38151 5.25C10.0777 5.25 10.7454 4.97344 11.2377 4.48116C11.7299 3.98887 12.0065 3.32119 12.0065 2.625C12.0065 1.92881 11.7299 1.26113 11.2377 0.768845C10.7454 0.276562 10.0777 0 9.38151 0C8.68532 0 8.01764 0.276562 7.52535 0.768845C7.03307 1.26113 6.75651 1.92881 6.75651 2.625C6.75651 3.32119 7.03307 3.98887 7.52535 4.48116C8.01764 4.97344 8.68532 5.25 9.38151 5.25ZM8.94401 26.25V19.25H9.81901V26.25C9.81901 27.218 10.601 28 11.569 28C12.537 28 13.319 27.218 13.319 26.25V10.5H16.3815H19.8815H20.7565C21.7245 10.5 22.5065 9.71797 22.5065 8.75C22.5065 7.78203 21.7245 7 20.7565 7H19.2412H12.176H8.57213C6.72917 7 5.02292 7.96797 4.07135 9.54844L0.883072 14.8531C0.385416 15.6789 0.653385 16.7563 1.47917 17.2539C2.30495 17.7516 3.38229 17.4836 3.87995 16.6578L5.44401 14.0492V26.25C5.44401 27.218 6.22604 28 7.19401 28C8.16198 28 8.94401 27.218 8.94401 26.25Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div className="text-area text-center">
                      <h6 className="mb-0">Arm Height Offsets (in)</h6>
                    </div>
                  </div>
                </div>
                {/* <div className="text-area ">
                  <h6 className="mb-0 slate-gray text-right"></h6>
                </div> */}
                <TrendlineGraph
                  graphDetails={graphDetails}
                  setSelectedIndex={() => {}}
                  setIsGraphClicked={() => {}}
                  circleClicked={() => {}}
                  yMappings={null}
                  allowNegative={true}
                  isReportGraph={true}
                ></TrendlineGraph>
              </div>
            ) : (
              <></>
            )}
            <div className="table-heading-wrap">
              <h3>Performance Summary</h3>
              <div className="assessment-info-new-table training-table af-bp-table-cols table first-table">
                <table
                  className="table two-col table-col-{{ table.Columns.length }} table-border-0"
                  aria-describedby="Assessment-Info-Table"
                >
                  <thead className="table-head">
                    <tr>
                      <th scope="col" className="fz-16 fw-700 text-left">
                        Measure
                      </th>
                      <th scope="col" className="fz-16 fw-700">
                        Value
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Score</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>{formatNumber(score.score)}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Good Apples Caught</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>{formatNumber(score.goodApples)}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Bad Apples Caught</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>{formatNumber(score.badApples)}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Good Apple %</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.goodApplePercentageCaught)
                            ? "-"
                            : formatNumber(
                                score.goodApplePercentageCaught * 100
                              )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Bad Apple %</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>
                          {Number.isNaN(score.badApplePercentageCaught)
                            ? "-"
                            : formatNumber(
                                score.badApplePercentageCaught * 100
                              )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Bad Apples Missed</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>{formatNumber(score.applesMissed)}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="fz-14 fw-600 text-left">
                        <span>Best Streak</span>
                      </td>
                      <td className="fz-14 fw-600">
                        <span>{formatNumber(score.bestStreak)}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {isShowArmsMetrics && (
              <div className="table-heading-wrap">
                <h3>Arm Metrics</h3>
                <div className="assessment-info-new-table training-table af-bp-table-cols table">
                  <table
                    className="table two-col table-col-{{ table.Columns.length }} table-border-0"
                    aria-describedby="Assessment-Info-Table"
                  >
                    <thead className="table-head">
                      <tr>
                        <th scope="col" className="fz-16 fw-700 text-left">
                          Measure
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Value
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fz-14 fw-600 text-left">
                          <span>Both Arms Duration (s)</span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.bothArmDuration)
                              ? "-"
                              : formatNumber(score.bothArmDuration)}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    className="table three-col table-col-{{ table.Columns.length }} table-border-0"
                    aria-describedby="Assessment-Info-Table"
                  >
                    <thead className="table-head">
                      <tr>
                        <th scope="col" className="fz-16 fw-700 text-left">
                          Measure
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Left
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Right
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fz-14 fw-600 text-left">
                          <span>Max Arm reach (in)</span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxArmReachLeft)
                              ? "-"
                              : formatNumber(score.maxArmReachLeft)}
                          </span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxArmReachRight)
                              ? "-"
                              : formatNumber(score.maxArmReachRight)}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {isShowLateralMetrics && (
              <div className="table-heading-wrap">
                <h3>Lateral Step Metrics</h3>
                <div className="assessment-info-new-table training-table af-bp-table-cols table">
                  <table
                    className="table two-col table-col-{{ table.Columns.length }} table-border-0"
                    aria-describedby="Assessment-Info-Table"
                  >
                    <thead className="table-head">
                      <tr>
                        <th scope="col" className="fz-16 fw-700 text-left">
                          Measure
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Value
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fz-14 fw-600 text-left">
                          <span>Total Lateral Movement (in)</span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.totalLateralMovement)
                              ? "-"
                              : formatNumber(score.totalLateralMovement)}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="fz-14 fw-600 text-left">
                          <span>Max Step Length (in)</span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxLateralStepLength)
                              ? "-"
                              : formatNumber(score.maxLateralStepLength)}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    className="table three-col table-col-{{ table.Columns.length }} table-border-0"
                    aria-describedby="Assessment-Info-Table"
                  >
                    <thead className="table-head">
                      <tr>
                        <th scope="col" className="fz-16 fw-700 text-left">
                          Measure
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Left
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Right
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fz-14 fw-600 text-left">
                          <span>Max Step (in)</span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxLateralStepLengthLeft)
                              ? "-"
                              : formatNumber(score.maxLateralStepLengthLeft)}
                          </span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxLateralStepLengthRight)
                              ? "-"
                              : formatNumber(score.maxLateralStepLengthRight)}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {isShowLeanMetrics && (
              <div className="table-heading-wrap">
                <h3>Lean Metrics</h3>
                <div className="assessment-info-new-table training-table af-bp-table-cols table">
                  <table
                    className="table three-col table-col-{{ table.Columns.length }} table-border-0"
                    aria-describedby="Assessment-Info-Table"
                  >
                    <thead className="table-head">
                      <tr>
                        <th scope="col" className="fz-16 fw-700 text-left">
                          Measure
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Left
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Right
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fz-14 fw-600 text-left">
                          <span>Max Lean Angle(&deg;)</span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxLeanAngleLeft)
                              ? "-"
                              : formatNumber(score.maxLeanAngleLeft)}
                          </span>
                        </td>
                        <td className="fz-14 fw-600">
                          <span>
                            {Number.isNaN(score.maxLeanAngleRight)
                              ? "-"
                              : formatNumber(score.maxLeanAngleRight)}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  );
};

export default AF_Test;
